import { translate } from "@/i18n/i18n";
import { formatTime } from "@/lib/utils";
import { CooldownTrainType } from "@ailenax-overlay/shared";
import { FC, useCallback, useEffect, useState } from "react";

interface CooldownProps {
    train: CooldownTrainType;
    offset: number;
}

export const Cooldown: FC<CooldownProps> = ({ train, offset }) => {
    const [timeRemaining, setTimeRemaining] = useState<number>(0);

    const updateTime = useCallback(() => {
        const now = new Date();
        const msRemaining = train.cooldownReadyAt.getTime() - now.getTime() - offset;
        setTimeRemaining(~~(msRemaining / 1000));
    }, [train, offset]);

    useEffect(() => {
        updateTime();
        const interval = setInterval(updateTime, 1000);

        return () => clearInterval(interval);
    }, [updateTime]);
    
    return (
        <div className="w-[100%] h-[100%] px-3 flex flex-col justify-center items-center text-2xl">
            <div className="flex flex-row items-center justify-between">
                <div className="flex-1">
                    <img src="https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_19b1cfbfc4a749eca6ed63ce21112215/default/dark/3.0" style={{ display: "inline", position: "relative", top: "-2px", height: "2.5rem" }}/>
                    <img src="https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_032e2c9c44604e8b82e5ee1bf3cb496c/default/dark/3.0" style={{ display: "inline", position: "relative", top: "-2px", height: "2.5rem" }}/>
                    <img src="https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_14e53a08453544f2bb346b3b91ea29e8/default/dark/3.0" style={{ display: "inline", position: "relative", top: "-2px", height: "2.5rem" }}/>
                    { translate("DONO_TRAIN_COOLDOWN") }
                </div>
                <div className="w-25 text-end text-3xl">
                    { formatTime(Math.max(0, timeRemaining)) }
                </div>
            </div>
        </div>
    );
}